var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('notifications'),_c('div',{class:{'nav-open': _vm.$sidebar.showSidebar}},[(_vm.$store.state.authentication.loggedIn)?_c('router-view'):_vm._e(),(!_vm.$store.state.authentication.loggedIn)?_c('login'):_vm._e()],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-011d95f4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 